import { gsap } from "gsap";

document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".js-front-header");
  if (!header) return;

  const logo = header.querySelector(".js-front-header__logo");
  const hamburger = header.querySelector(".js-front-header__hamburger");
  const translation = header.querySelector(".js-front-header__translation");
  const navList = header.querySelector(".js-front-header__list");
  const cv = header.querySelector(".js-front-header__cv");

  const targets = [logo, hamburger, translation, navList, cv].filter(Boolean);

  window.addEventListener("load", () => {
    gsap.to(targets, {
      delay: 4.3,
      opacity: 1,
      duration: 1,
      ease: "power2.out"
    });
  });
});